@if (calendarButtons(); as buttons) { @if (buttons.length) {
<div class="push-bottom">
	<lib-button-list [buttons]="buttons"></lib-button-list>
</div>
}} @if (extendedAppointments(); as extendedAppointments) {
<div>
	@if (extendedAppointments.length === 0) {
	<div>
		<lib-message [type]="'noDataOnBody'">
			@if (sharedData()?.data?.mode === 'upcoming') { You have no upcoming appointments } @else { You have no past
			appointments }
		</lib-message>
	</div>
	} @if (extendedAppointments.length) {
	<div [libFlexRow]="true" [libFlexRowGap]="'24px'">
		@for (extendedAppointment of extendedAppointments; track extendedAppointment.id; let first = $first) {
		<div libFlexColumn [style.width]="styleWidth()">
			<lib-card
				style="height: 100%"
				[avatar]="extendedAppointment.avatar"
				[avatarName]="extendedAppointment.item.system.name"
				[title]="extendedAppointment.item.system.name"
				[subtitle]="extendedAppointment.fromNow"
				[buttons]="extendedAppointment.cardButtons"
			>
				<div>
					<ui-simple-table [items]="extendedAppointment.simpleTableItems"></ui-simple-table>
				</div>
			</lib-card>
		</div>
		}
	</div>
	}
</div>
}
